export default __webpack_public_path__ + "static/media/TWS.734523a3.svg";